export default __webpack_public_path__ + "static/media/6.08d39a2c.png";